



















































import Vue from 'vue';
import { API } from '@/api';
import { mapActions } from 'vuex';

export default Vue.extend({
  data: () => ({
    openDialog: false,
    rules: [(v) => (v.length === 0 || v.length === 18) || 'La CLABE debe ser de 18 caracteres'],
    nuevaCuenta: {
      creationUsername: '',
      creationDateTime: '',
      propCuenta: '',
      numCuenta: '',
      banco: '',
      clabe: '',
      principal: false,
      ctaContable: '',
      eliminada: false,
    },
    isPrincipal: '',
    Bancos: [],
    loading: false,
  }),
  mounted() {
    this.loadData();
  },
  computed: {
    readonly() {
      if (!this.nuevaCuenta.numCuenta || !(this.nuevaCuenta.clabe.length === 18)) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapActions(['getImpuesto']),
    modeloCuenta() {
      return {
        creationDateTime: '',
        creationUsername: '',
        propCuenta: '',
        numCuenta: '',
        banco: '',
        clabe: '',
        principal: false,
        eliminada: false,
      };
    },
    async loadData() {
      this.loading = true;
      try {
        const result = await this.$store.dispatch('getBancos');
        this.Bancos = result;
        console.debug('Bancos: %o', this.Bancos);
      } catch (e) {
        console.error(e);
        this.$toast.error(e);
      }
      this.loading = false;
    },
    async AgregarCuenta() {
      if (this.nuevaCuenta.nombre === '' /*|| this.nuevaCuenta.ctaContable === ''*/) {
        this.$toast.error('Es necesario poner un numero de cuenta y un número de cuenta contable');
        return;
      }
      try {
        this.loading = true;
        this.nuevaCuenta.creationDateTime = this.$moment().format();
        this.nuevaCuenta.creationUsername = this.$store.getters.getUsername;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const cuenta = this.nuevaCuenta;
        const datos = {admin, condo, cuenta};
        console.log('datos: %o', datos);
        const result = await this.$store.dispatch('addCuenta', {datos} );
        console.debug('Respuesta addPropietCondo: %o', result);
        this.$toast.success('Cuenta agregada');
      } catch (e) {
        console.error(e);
        this.$toast.error(e.response.data.message);
      }
      this.loading = false;
      this.openDialog = false;
      this.$emit('reload', {});
    },
    restrictChars($event) {
      if (/[0-9]/.test(String.fromCharCode($event.charCode))) {
        return true;
      } else {
        $event.preventDefault();
      }
    },
  },
  watch: {
    openDialog() {
      if (!this.openDialog) {
        this.nuevaCuenta = this.modeloCuenta();
      }
    },
  },
});
